import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import SummaryFlights from 'components/components/common/SummaryFlights';

class SummaryFlightsContainer extends Component {
  render() {
    return (<SummaryFlights {...this.props} />);
  }
}

const mapStateToProps = (state) => {
  return {
    airportFrom: state.booking.airportFrom,
    airportTo: state.booking.airportTo,
    adultsNumber: state.booking.adultsNumber,
    childrenNumber: state.booking.childrenNumber,
    studentsNumber: state.booking.studentsNumber,
    departureFlight: state.booking.departureFlight,
    returnFlight: state.booking.returnFlight,
    returnAddress: state.booking.returnAddress,
    departureAddress: state.booking.departureAddress,
    differentReturnAddress: state.booking.differentReturnAddress,
    locale: state.app.locale
  };
};

export default connect(mapStateToProps)(SummaryFlightsContainer);
